import * as React from "react";
import { connect } from "react-redux";
import { ICoworkSpace } from "shared/model/ICoworkSpace";

import { IState } from "../../../state/modules";
import ApplicationsSelectors from "../../../state/modules/applications/ApplicationsSelectors";
import AuthSelectors from "../../../state/modules/auth/AuthSelectors";
import { Dispatch } from "../../../state/store/store";
import MenuButton from "./MenuButton";

interface IProps {
  className?: string;
  isSignedIn?: boolean;
  onSignOut?: () => void;
  currentCowork?: ICoworkSpace;
  myAccount?: boolean;
}

interface IButtonState {
  isOpen: boolean;
}

@(connect(
  (state: IState, ownProps: IProps): Partial<IProps> => ({
    isSignedIn: AuthSelectors.isSignedIn(state.auth),
    onSignOut: Dispatch.auth.signOut,
    currentCowork: ApplicationsSelectors.currentCowork(state.applications)
  })
) as any)
export default class MenuButtonContainer extends React.Component<
  IProps,
  IButtonState
> {
  public state: IButtonState = {
    isOpen: false
  };

  public render() {
    const { isSignedIn, onSignOut, className, currentCowork, myAccount } = this.props;
    const { isOpen } = this.state;
    return  <MenuButton
              isSignedIn={isSignedIn!}
              onSignOut={onSignOut!}
              isOpen={isOpen}
              className={className}
              avatarUrl={currentCowork && currentCowork.avatarUrl}
              onMenuToggled={this.onMenuToggled}
              onMenuClosed={this.onMenuClosed}
              isMyAccount={myAccount}
          />
  }

  private onMenuToggled = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  private onMenuClosed = () => {
    this.setState({ isOpen: false });
  };
}



// WEBPACK FOOTER //
// ./src/components/Header/MenuButton/MenuButtonContainer.tsx